import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { CheckCircle2, Truck, MessageCircle } from 'lucide-react';
import { fmtRM2 } from '../data/mockData';
import { useApp } from '../context/AppContext';
import { waLink, orderWaMessage } from '../lib/wa';

const METHOD_LABELS = { CASH: 'Cash', TNG_QR: 'TNG QR', BANK_TRANSFER: 'Bank Transfer', WALLET: 'KELATE Wallet' };

export default function CheckoutSuccessPage() {
  const { state } = useLocation();
  const { orders, merchantById } = useApp();
  const orderNumbers = state?.orderNumbers || [];
  const orderIds = state?.orderIds || [];
  const placed = orders.filter((o) => orderIds.includes(o.id));

  return (
    <div data-testid="checkout-success-page" className="mx-auto max-w-[620px] px-4 py-16">
      <div className="rounded-3xl bg-kelate-surface shadow-[0_1px_4px_rgba(81,68,55,0.08)] p-8 text-center">
        <CheckCircle2 size={48} className="mx-auto text-kelate-sage" strokeWidth={1.5} />
        <h1 className="mt-4 font-display text-3xl font-semibold text-kelate-darkwood">Order Confirmed</h1>
        <div className="mt-2 text-sm text-kelate-soft">
          {orderNumbers.length > 0 ? orderNumbers.map((n) => <div key={n} className="font-semibold text-kelate-ink" data-testid="success-order-number">Order #{n}</div>) : 'Your order has been placed.'}
        </div>
        <div className="mx-auto mt-6 max-w-xs space-y-2 rounded-sm bg-secondary/60 p-4 text-sm">
          {state?.total != null && <div className="flex justify-between"><span className="text-kelate-soft">Total</span><span className="font-semibold text-kelate-darkwood" data-testid="success-total">{fmtRM2(state.total)}</span></div>}
          <div className="flex justify-between"><span className="text-kelate-soft">Delivery</span><span className="flex items-center gap-1 text-kelate-ink"><Truck size={13} className="text-kelate-sage" /> KELATE Delivery</span></div>
          <div className="flex justify-between"><span className="text-kelate-soft">Payment</span><span className="font-medium text-kelate-ink">{METHOD_LABELS[state?.method] || 'Cash'} · {state?.method === 'WALLET' ? 'PAID VIA WALLET' : 'PAY ON DELIVERY'}</span></div>
          <div className="flex justify-between"><span className="text-kelate-soft">Estimated delivery</span><span className="text-kelate-ink">Today - Tomorrow</span></div>
        </div>
        <div className="mt-5 space-y-2" data-testid="wa-confirm-section">
          <p className="text-xs font-medium uppercase tracking-widest text-kelate-soft">Double-confirm with your merchant</p>
          {placed.map((o) => {
            const m = merchantById(o.merchantId);
            const phone = m?.whatsapp || m?.phone;
            if (!phone) return null;
            return (
              <a key={o.id} data-testid={`wa-confirm-${o.orderNumber}`} href={waLink(phone, orderWaMessage(o, o.merchantName))} target="_blank" rel="noreferrer"
                className="flex items-center justify-center gap-2 rounded-xl bg-[#25D366] px-4 py-2.5 text-sm font-semibold text-white transition-opacity hover:opacity-90">
                <MessageCircle size={16} /> WhatsApp order #{o.orderNumber} to {o.merchantName}
              </a>
            );
          })}
          <p className="text-[11px] text-kelate-soft">KELATE ops also forwards every order to the merchant on WhatsApp.</p>
        </div>
        <div className="mt-6 flex flex-col gap-2 sm:flex-row sm:justify-center">
          <Link to={orderIds[0] ? `/my-kelate/orders/${orderIds[0]}` : '/my-kelate/orders'} data-testid="track-order-btn" className="rounded-sm bg-kelate-darkwood px-5 py-2.5 text-sm font-medium text-kelate-surface hover:bg-kelate-wood">
            Track Order
          </Link>
          <Link to="/marketplace" data-testid="continue-shopping-btn" className="rounded-sm border border-kelate-darkwood px-5 py-2.5 text-sm font-medium text-kelate-darkwood hover:bg-secondary">
            Continue Shopping
          </Link>
        </div>
      </div>
    </div>
  );
}
